import { Button, Input, Table } from 'antd';
import { Formik } from 'formik';
import React from 'react';
import { useNavigate } from 'react-router';

import Modal from '../../../foundation/components/modal/Modal';
import { MUTED_TEXT } from '../../../foundation/config/colors';
import { useModalForm } from '../../../foundation/hooks';
import { VARIANT_STAGE_TYPES } from '../constants/stages';
import { VariantSample } from '../redux/types';
import { getSampleVariantColumns } from '../utils/sampleVariantColumns';

type SampleModalType = {
  closeModal: () => void;
  sample?: VariantSample;
};

interface FormValues {
  subject_external_id?: string;
  birthdate?: string;
  gender?: string;
}

const SubjectModal = ({ closeModal, sample }: SampleModalType) => {
  const navigate = useNavigate();

  const { handleModalClose, createModalOpts } = useModalForm({
    onClose: closeModal,
    stageType: VARIANT_STAGE_TYPES.CLINICAL_OBSERVATION,
  });

  const modalOpts = {
    ...createModalOpts(''),
  };

  const handleFormSubmit = async (values: any) => {
    handleModalClose();
  };

  const variantTableColumns = getSampleVariantColumns(navigate);

  return (
    <Modal {...modalOpts} className="h-proband-modal">
      <Formik
        initialValues={
          {
            subject_external_id: sample?.subject_external_id,
            birthdate: sample?.birthdate,
            gender: sample?.gender,
          } as FormValues
        }
        enableReinitialize
        onSubmit={handleFormSubmit}
      >
        {({ values, handleSubmit }) => {
          return (
            <form onSubmit={handleSubmit}>
              <div className="c-form-field">
                <div className="c-form-field__label">Subject ID:</div>
                <div className="c-form-field__wrapper">
                  <Input
                    name="subject_external_id"
                    type="text"
                    value={values.subject_external_id}
                    disabled
                  />
                </div>
              </div>

              <div className="c-form-field">
                <div className="c-form-field__label">Birthday:</div>
                <div className="c-form-field__wrapper">
                  <Input
                    name="birthdate"
                    type="text"
                    value={values.birthdate}
                    disabled
                  />
                </div>
              </div>

              <div className="c-form-field">
                <div className="c-form-field__label">Gender:</div>
                <div className="c-form-field__wrapper">
                  <Input
                    name="gender"
                    type="text"
                    value={values.gender}
                    disabled
                  />
                </div>
              </div>

              {sample?.all_subject_samples &&
                sample.all_subject_samples.map((item) => (
                  <div key={item.sample_external_id}>
                    <div className="c-form-field">
                      <div className="c-form-field__label">Sample ID:</div>
                      <div className="c-form-field__wrapper">
                        <Input
                          name="subject_external_id"
                          type="text"
                          value={item.sample_external_id}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="c-form-field">
                      <div className="c-form-field__label">Variants:</div>
                      <div className="c-form-field__wrapper">
                        {item?.genotype_variants &&
                        item.genotype_variants.length > 0 ? (
                          <Table
                            dataSource={item.genotype_variants}
                            pagination={false}
                            showHeader={false}
                            bordered={false}
                            size="small"
                            columns={variantTableColumns}
                          />
                        ) : (
                          <div
                            style={{ color: MUTED_TEXT, fontStyle: 'italic' }}
                          >
                            No variants found for this sample
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}

              <div className="c-form__btn-wrapper h-proband-modal__form-btn-wrapper">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="h-proband-modal__form-submit-btn"
                  disabled
                >
                  Save changes
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default SubjectModal;
